import { createContext } from "react";

import type { StoreProvider } from "./store";
import type { PlatformProviderState } from "./types";

export const PlatformContext = createContext<
  StoreProvider<PlatformProviderState<unknown>>
>(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  undefined!
);
